import { render, staticRenderFns } from "./profile-editor.vue?vue&type=template&id=776f2721&"
import script from "./profile-editor.vue?vue&type=script&lang=ts&"
export * from "./profile-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports